import React from "react";
import style from "./Dashboard.module.css";

/**
 * Custom flag icon for Career Path section.
 * Matches design: green wavy flag on pole, with dot connecting to timeline.
 */
const CareerPathFlag = () => (
  <span className={style.careerPathFlag} aria-hidden>
    <svg
      width="48"
      height="48"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Green anchor dot on timeline */}
      <circle cx="9" cy="14" r="2.5" fill="#22C55E" />
      {/* Flagpole */}
      <line
        x1="9"
        y1="14"
        x2="9"
        y2="4"
        stroke="#22C55E"
        strokeWidth="1"
      />
      {/* Wavy flag shape - fluttering to the right */}
      <path
        d="M9 4 L9 12 C12 11 15 12 18 10 C19.8 9 21 10 21.2 8 L21.2 5 C19.8 6 17 5 15 6 C13 7 11 6 9 4 Z"
        fill="#22C55E"
      />
    </svg>
  </span>
);

export default CareerPathFlag;
